import getAutomaticRepliesOptionStateDefaultValue from '../../utils/getAutomaticRepliesOptionStateDefaultValue';
import { createStore } from 'satcheljs';
export default createStore('automaticRepliesOption', {
    initialState: getAutomaticRepliesOptionStateDefaultValue(),
    currentState: getAutomaticRepliesOptionStateDefaultValue(),
    selectedCalendarIds: [],
});
//# sourceMappingURL=store.js.map